import { z } from "zod";

export const leadFormSchema = z.object({
  first_name: z
    .string()
    .min(1, "First name is required")
    .transform((v) => v.trim())
    .pipe(z.string().min(1, "First name cannot be empty")),
  last_name: z
    .string()
    .min(1, "Last name is required")
    .transform((v) => v.trim())
    .pipe(z.string().min(1, "Last name cannot be empty")),
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter a valid email address"),
  phone_number: z
    .string()
    .optional()
    .default("")
    .refine(
      (v) => !v || v.replace(/\D/g, "").length >= 10,
      "Phone number must have at least 10 digits"
    ),
  property_address: z
    .string()
    .min(1, "Property address is required"),
  sms_consent: z.boolean().default(false),
});
